// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mainContainer__u2lE5 {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
}

.row__UW2Xd {
  display: grid;
  grid-template-columns: 120px 1fr;
  row-gap: 12px;
}

.proposedConditionsContainer__P6CuT {
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 100%;
}

.conditions__qg5wu {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  justify-items: start;
}

.divider__Jyjmf {
  height: 1px;
  width: 100%;
  background-color: #d7e5ea;
}

@media (max-width: 950px) {
  .conditions__qg5wu {
    grid-template-columns: 1fr;
    justify-items: flex-start;
    grid-row-gap: 4px;
  }
}

.titleContainer__cM98P {
  display: flex;
  border: 1px solid #717171;
  width: 100%;
  border-radius: 6px;
  padding: 5px 8px;
  box-sizing: border-box;
  background-color: #f3f2fc;
}

.textContainer__Jc6gc {
  border-radius: 6px;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  padding: 0 8px;
  width: 100%;
  box-sizing: border-box;
}

@media print {
  .textContainer__Jc6gc {
    border-radius: 6px;
    font-family: 'Inter', sans-serif;
    font-size: 11px;
    padding: 0 8px;
    width: 100%;
    box-sizing: border-box;
  }

  .conditions__qg5wu {
    grid-template-columns: repeat(3, 1fr);
    justify-items: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/summary-notes-component/style.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE;IACE,0BAA0B;IAC1B,yBAAyB;IACzB,iBAAiB;EACnB;AACF;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,cAAc;EACd,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE;IACE,kBAAkB;IAClB,gCAAgC;IAChC,eAAe;IACf,cAAc;IACd,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,qCAAqC;IACrC,qBAAqB;EACvB;AACF","sourcesContent":[".mainContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.row {\n  display: grid;\n  grid-template-columns: 120px 1fr;\n  row-gap: 12px;\n}\n\n.proposedConditionsContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  width: 100%;\n}\n\n.conditions {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  justify-items: start;\n}\n\n.divider {\n  height: 1px;\n  width: 100%;\n  background-color: #d7e5ea;\n}\n\n@media (max-width: 950px) {\n  .conditions {\n    grid-template-columns: 1fr;\n    justify-items: flex-start;\n    grid-row-gap: 4px;\n  }\n}\n\n.titleContainer {\n  display: flex;\n  border: 1px solid #717171;\n  width: 100%;\n  border-radius: 6px;\n  padding: 5px 8px;\n  box-sizing: border-box;\n  background-color: #f3f2fc;\n}\n\n.textContainer {\n  border-radius: 6px;\n  font-family: 'Inter', sans-serif;\n  font-size: 14px;\n  padding: 0 8px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n@media print {\n  .textContainer {\n    border-radius: 6px;\n    font-family: 'Inter', sans-serif;\n    font-size: 11px;\n    padding: 0 8px;\n    width: 100%;\n    box-sizing: border-box;\n  }\n\n  .conditions {\n    grid-template-columns: repeat(3, 1fr);\n    justify-items: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainContainer": `mainContainer__u2lE5`,
	"row": `row__UW2Xd`,
	"proposedConditionsContainer": `proposedConditionsContainer__P6CuT`,
	"conditions": `conditions__qg5wu`,
	"divider": `divider__Jyjmf`,
	"titleContainer": `titleContainer__cM98P`,
	"textContainer": `textContainer__Jc6gc`
};
export default ___CSS_LOADER_EXPORT___;
